<app-header title="Impressum" i18n-title/>

<main>
  <div class="m-5 p-1">
    <p class="fw-bold" i18n>Angaben gemäß § 5 DDG:</p>
    <p class="d-flex flex-column">
      <span i18n>ser.soft GmbH</span>
      <span i18n>Gräfental 7</span>
      <span i18n>75057 Kürnbach</span>
    </p>

    <p class="fw-bold" i18n>Vertretungsberechtigte Geschäftsführer:</p>
    <p class="d-flex flex-column">
      <span i18n>Dipl.-Inform. Georg Ziegler</span>
      <span i18n>Wi-Inf. Daniel Friedrich</span>
    </p>

    <p class="fw-bold" i18n>Kontakt:</p>
    <p class="d-flex flex-column">
      <span class="d-inline-flex flex-row flex-wrap gap-2">
        <span i18n>Telefon:</span>
        <span i18n>+49-721-93519-60</span>
      </span>
      @if (showTelefax) {
        <span class="d-inline-flex flex-row flex-wrap gap-2">
          <span i18n>Telefax:</span>
          <span i18n>+49-721-93519-79</span>
        </span>
      }
      @defer {
        <span class="d-inline-flex flex-row flex-wrap gap-2">
          <span i18n>E-Mail:</span>
          <span id="sg-email-address"></span>
        </span>
      }
    </p>

    <p class="fw-bold" i18n>Registereintrag:</p>
    <p i18n>
      Eintragung im Handelsregister. <br>
      Registergericht: Amtsgericht Mannheim <br>
      Registernummer: HRB 109636
    </p>

    <p class="fw-bold" i18n>Umsatzsteuer-ID:</p>
    <p i18n>
      Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: <br>
      DE218354759
    </p>

    <p class="fw-bold" i18n>Angaben zur Berufshaftpflichtversicherung:</p>
    <p i18n>
      Name und Sitz der Gesellschaft: <br><br>

      Chubb Insurance Company of Europe SE <br>
      Direktion für Deutschland <br>
      Grafenberger Allee 295 <br>
      40237 Düsseldorf <br><br>

      Geltungsraum der Versicherung: Weltweit
    </p>

    <p class="fw-bold" i18n>Angaben zum Streitbeilegungsverfahren:</p>
    <p i18n>
      Wir nehmen nicht an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.
      Das Gesetz über die alternative Streitbeilegung in Verbrauchersachen fordert aber, dass wir
      Sie trotzdem auf eine für Sie zuständige Verbraucherschlichtungsstelle hinweisen: <br><br>

      Allgemeine Verbraucherschlichtungsstelle des Zentrums für Schlichtung e. V. <br>
      Straßburger Str. 8 <br>
      77694 Kehl <br>
      www.verbraucher-schlichter.de
    </p>

    <p class="fw-bold" i18n>Widerspruch Werbe-Mails:</p>
    <p i18n>
      Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von
      nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen.
      Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten
      Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.
    </p>

    <p class="fw-bold" i18n>Datenschutz:</p>
    <p i18n>Es gilt die <a [routerLink]="['/privacy']">Datenschutzerklärung</a> der ser.soft GmbH.</p>
  </div>

  <app-large-logo-shear/>
</main>
